import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import PasswordInput from '../../../components/password-input'
import SettingsCard from '../../../components/Settings/SettingsCard'
import { SettingsField } from '../../../components/Settings/ClearableInput'

/**
 * Password update.
 *
 * The design shows a "last updated on <date>" line, which is omitted here:
 * there is no password_updated_at field on the user object, so it could only
 * ever display a fabricated date.
 */
export default function PasswordCard({
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
  onSaveNewPassword,
}) {
  const { t } = useTranslation()

  const mismatch =
    !!newPassword && !!confirmPassword && newPassword !== confirmPassword

  const canSave =
    !!newPassword &&
    !!confirmPassword &&
    newPassword === confirmPassword &&
    newPassword.length >= 6

  return (
    <SettingsCard
      id="password"
      icon="lock"
      title={t('users.edit.update_pw')}
      actions={
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSaveNewPassword}
          disabled={!canSave}
        >
          {t('users.edit.save')}
        </button>
      }
    >
      <div className="row">
        <div className="col-md-6">
          <SettingsField
            label={t('users.edit.new_pw')}
            htmlFor="inputNewPassword"
            help={`${t('users.edit.pw_requirements')} _!@%&()*''.`}
          >
            <PasswordInput
              onChange={val => setNewPassword(val)}
              showPasswordToggle
              value={newPassword || ''}
              autofocus={false}
            />
          </SettingsField>
        </div>
        <div className="col-md-6">
          <SettingsField
            label={t('users.edit.confirm_pw')}
            htmlFor="confirmPassword"
            help={
              mismatch
                ? t('users.edit.pw_mismatch', 'Passwords do not match')
                : null
            }
            helpVariant={mismatch ? 'error' : undefined}
          >
            <PasswordInput
              onChange={val => setConfirmPassword(val)}
              showPasswordToggle
              value={confirmPassword || ''}
              autofocus={false}
            />
          </SettingsField>
        </div>
      </div>
    </SettingsCard>
  )
}

PasswordCard.propTypes = {
  newPassword: PropTypes.string,
  setNewPassword: PropTypes.func.isRequired,
  confirmPassword: PropTypes.string,
  setConfirmPassword: PropTypes.func.isRequired,
  onSaveNewPassword: PropTypes.func.isRequired,
}
